import axios from 'axios';

const first =
  'se3ba02511982d5c56b4dfda6ac89cb23fdfe8df01ca09d71fed6e69d4d8e0822';
const secend = ':ncms1!2@3#4$';
const encodeValue = btoa(first + secend);

// 비로그인
export default axios.create({
  baseURL: 'https://mall-api.mallpie.kr/v2',
  headers: {
    'Content-Type': 'application/json',
    Authorization: encodeValue,
    ShopId:
      typeof window !== 'undefined' && window.location.hostname.split('.')[0],
  },
});

// 로그인
export const axiosAuth = axios.create({
  baseURL: 'https://mall-api.mallpie.kr/v2',
  headers: {
    'Content-Type': 'application/json',
    Authorization: encodeValue,
    ShopId:
      typeof window !== 'undefined' && window.location.hostname.split('.')[0],
  },
});
